import { render } from "./index.vue?vue&type=template&id=cdb67002&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cdb67002&scoped=true&lang=scss"

import exportComponent from "D:\\work\\cs-player\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb67002"]])

export default __exports__